/**
 * 好友申请列表
 */
import React, {Component} from 'react';
import { ImageView, Gender, Grade, OfficialAuth} from '../../component/user-ui';
import lang from '../../lang';

class FriendApplyListView extends Component {
	static defaultProps = {
		list: [],
		onFollowFriend: function(){}
	}

	render() {
		return (
			<div className="apply-list hostlist-lite">
				<ul>
				{ 
					this.props.list.map((item, index)=>{
						return (
							<li key={index}>
								<FriendApplyItemView data={item} onFollowFriend={this.props.onFollowFriend}/>
							</li>
						);	
					})
				}
				</ul>
				{
					this.props.list.length == 0 ? <div className="mini-tip">{lang.template('暂无好友申请')}</div> : null
				}
			</div>
		);
	}
}

class FriendApplyItemView extends Component {
	static defaultProps = {
		data: {},
		onFollowFriend: function(){}
	}

	render() {
		let data = this.props.data;
		let userInfo = data.userInfo;
		
		return (
			<div className="list-item" data-uid={data.sid}>
                <div className="avatar">
                    <ImageView src={userInfo.avatar} size={40} circle/>
                    { userInfo.officialAuth > 0 ? <OfficialAuth value={userInfo.officialAuth}/> : null }
                </div>
                <div className="refbox">
                    <div className="user">
                        <div className="username">{userInfo.username}</div>
                        <Gender key="gender" value={userInfo.gender}/>
                        <Grade key="grade" value={userInfo.grade}/>
                    </div>
                    <div className="info">{ data.verifyMsg}</div>
                </div>
                <div className="extra">
                	{ 
                		data.unhandled ? <span className="adding" onClick={this.props.onFollowFriend.bind(this, data.sid)}>{lang.template('添加')}</span> : <span className="added">{lang.template('已添加')}</span>
                	}
                </div>
            </div>
		);
	}
}

export default FriendApplyListView;


// WEBPACK FOOTER //
// ./js/im/views/apply-list.js